export class KaiyakuForInput {
    keyReturnMinTime = "00:00";
    keyReturnMaxTime = "23:59";
    keyReturnName = "";
    keyReturnNameKb = 0;
    taikyoButtonShowDays = 14;
    tachiaishaKbnList = [];
    accountKbnList = [];
    selectedTachiaishaKbn = null;
    selectedTachiaishaKbnName = "";
    appliedInput = false;
}
